import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CPSearchInputComponent } from './cp-search-input/cp-search-input.component';
import { CPSearchTargetComponent } from './cp-search-target/cp-search-target.component';
import { CPSearchComponent } from './cp-search.component';
import { WindowModule, DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule, PDFModule, ExcelModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { DatePickerModule, DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { LayoutModule } from '@angular/cdk/layout';
import { PopupModule } from '@progress/kendo-angular-popup';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { EditorModule } from '@progress/kendo-angular-editor';
import { UploadModule } from '@progress/kendo-angular-upload';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { GenericSearchModule } from '../generic-search/generic-search.module';
import { pipeModule } from '@app/cp/shared/pipes/pipe.module'

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        DropDownsModule,
        DateInputsModule,
        DatePickerModule,
        EditorModule,
        UploadModule,
        GridModule,
        TooltipModule,
        WindowModule,
        PDFModule,
        ChartsModule,
        GaugesModule,
        PDFExportModule,
        ExcelModule,
        ButtonsModule,
        InputsModule,
        ExcelExportModule,
        ScrollViewModule,
        DialogsModule,
        PopupModule,
        GenericSearchModule,
        pipeModule
    ],
    declarations: [
        CPSearchComponent,
        CPSearchInputComponent,
        CPSearchTargetComponent
    ], 
    exports: [
        CPSearchComponent,
        CPSearchInputComponent,
        CPSearchTargetComponent
    ]
})
export class CPSearchModule { }
